import { createPortal } from 'react-dom';

import type { ReactNode } from 'react';

type PortalProps = {
  children: ReactNode;
  container?: HTMLElement;
};

export const Portal = ({ children, container = document.body }: PortalProps) => createPortal(children, container);
